import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  // height: 420px;
  width: 420px;
`;

export const CardHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #101e8e;
  color: #fff;
  height: 20%;
  width: 100%;
  svg {
    color: #fff !important;
    path{
      color: #fff !important;
    }
  }
`;

export const CardContent = styled.div`
  height: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #101e8e;
  width: 420px;
`;
